/* global Stripe */
/* global TruTranslations */

class StripeField {

    constructor(key, locale) {
        this.stripe = Stripe(key, { locale: locale });
        this.test_val = "testing";
        var elements = this.stripe.elements();

        let style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: 'Montserrat, Arial, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#626262'
                }
            },
            invalid: {
                color: '#ff0000',
                iconColor: '#FF0000'
            }
        };

        this.card = elements.create("card", { style: style });
        this.card.mount($(".card-element", document)[0]);

        // Handle real-time validation errors from the card Element.
        this.card.addEventListener('change', function(event) {

            if (event.error) {
                if (event.error.code === "incomplete_zip") {
                    $('.card-errors', document).text(TruTranslations['stripe_incomplete_zip_msg']);
                } else {
                    $('.card-errors', document).text(event.error.message);
                }
            } else {
                $('.card-errors', document).text('');
            }
        });
    }

    createToken() {
        return this.stripe.createToken(this.card);
    }
}

export default StripeField;
